// extracted by mini-css-extract-plugin
export default {"sourceFeedClickable":"ConfigureFeedTable_sourceFeedClickable__ejGye","disabled":"ConfigureFeedTable_disabled__6Uw+b","feedTable":"ConfigureFeedTable_feedTable__3Uo-z"};